

export default {
    totalLaborOrders: [],
    laborOrders: [],
    laborOrdersFiltered: [],

}
